@let products = products$ | async;
@if (products && products.bento.length > 1) {
  <nav class="bv-product-switcher" [attr.aria-label]="'switchProducts' | i18n">
    @for (product of products.bento; track product.name) {
      <a
        class="bv-product-switcher__tab"
        [class.bv-product-switcher__tab--active]="product.isActive"
        [routerLink]="product.appRoute"
        [attr.aria-current]="product.isActive ? 'page' : null"
      >
        {{ product.name }}
      </a>
    }
  </nav>
}
